// Picture Record Class

import { m } from "@/utils/utils";
import store from "@/store/store";
import * as Utils from "@/utils/utils";

export default class PicRec {

	constructor(dat) {
		const src			= dat || {};

		// Record
		this.rid		= src.rid		|| 0;
		this.itemId		= src.itemId	|| "i" + Utils.genWord(4);
		this.artId		= src.artId		|| "a123";
		this.live		= src.live		|| "";
		this.sortKey	= src.sortKey	|| 0;
		this.fileExt	= src.fileExt	|| "";
		this.fileSize	= src.fileSize	|| 0;
		this.stage		= src.stage		|| "";
		this.merit		= src.merit		|| "";
		this.origName	= src.origName	|| "";
		this.imgName	= src.imgName	|| "";
		this.thmName	= src.thmName	|| "";
		this.dir		= src.dir		|| "";
		this.title		= src.title		|| "";
		this.credit		= src.credit	|| "";
		this.descr		= src.descr		|| "";
		this.notes		= src.notes		|| "";
		this.dateCre	= src.dateCre	|| "";
		this.dateMod	= src.dateMod	|| "";

		// Join info
		this.artRid		= src.artRid	|| 0;

		// Calculated info
		this.primary		= src.primary	|| false;
		this.step			= src.step		|| "none";
		this.refImage		= src.refImage	|| null;
		this.testObj		= {...src.testObj}

		// Upload info
		this.type			= src.type || "";
		this.rot 			= src.rot || 0;
		this.imgs			= {...src.imgs};

	}

	calcPrimary = (mainId) => {
		m("class calcPrimary");
		m("mainId: " + mainId + " itemId: " + this.itemId);
		this.primary = (this.itemId == mainId);	
		m("primary: " + this.primary);
	}

}

